import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { UserPreferencesUnsubscribeBaseCtrl } from './UserPreferencesUnsubscribeBaseCtrl';
import { IdentityResolves } from 'components/sharpr/identity/IdentityService';

export function UserPreferencesUnsubscribeRoute($stateProvider) {
	'ngInject';
	IdentityResolves({});

	$stateProvider.state('hub.loggedin.UserPreferencesUnsubscribe', {
		url: '/preferences/unsubscribe',
		controllerAs: 'vm',
		controller: UserPreferencesUnsubscribeCtrl,
		templateUrl: '/ng/hub/User/Preferences/Unsubscribe/UserPreferencesUnsubscribeCtrl.html?' + window.BUILD,
		permission: ['login'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/User/Preferences/Unsubscribe/UserPreferencesUnsubscribeCtrl.css'),
			$title: () => 'Email Preferences',
		},
	});
}

export class UserPreferencesUnsubscribeCtrl extends UserPreferencesUnsubscribeBaseCtrl {}
